import { lazy, Suspense, useCallback, useEffect, useState } from "react";
const Picker = lazy(() => import("@emoji-mart/react"));
import es from "@emoji-mart/data/i18n/es.json";
import en from "@emoji-mart/data/i18n/en.json";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

import { noop } from "@helpers/common";

import styles from "./index.module.scss";

const blackList = ["relaxed"];

const translationMap = {
  es,
  en,
};

const EmojiPickerPopover = ({ data, onSelect = noop }) => {
  const { t } = useTranslation("chat");
  const [locale, setLocale] = useState({
    name: "en",
    i18n: en,
  });

  useEffect(() => {
    const selectedLanguage = i18n.language;
    if (selectedLanguage !== locale.name && translationMap[selectedLanguage]) {
      setLocale({
        name: selectedLanguage,
        i18n: translationMap[selectedLanguage],
      });
    }
  }, [locale.name, i18n.language]);

  const onEmojiSelect = useCallback(
    (emoji) => onSelect(emoji.native),
    [onSelect],
  );

  const getFilteredEmojis = () => {
    return blackList.reduce((acc, currentValue) => {
      delete acc[currentValue];
      return acc;
    }, data.emojis);
  };

  const getFilteredData = () => {
    return {
      ...data,
      emojis: getFilteredEmojis(),
    };
  };

  return (
    <div
      className={classnames("d-flex flex-column", styles.emojiPickerWrapper)}
    >
      <Suspense fallback="Loading...">
        <Picker
          data={getFilteredData()}
          categories={[
            "people",
            "nature",
            "foods",
            "activity",
            "places",
            "objects",
            "symbols",
            "flags",
          ]}
          navPosition="none"
          previewPosition="none"
          skinTonePosition="none"
          set="apple"
          emojiSize={24}
          perLine={8}
          maxFrequentRows={5}
          emojiButtonSize={40}
          skin={1}
          onEmojiSelect={onEmojiSelect}
          locale={locale.name}
          i18n={{
            ...locale.i18n,
            ...t("PICKER"),
          }}
        />
      </Suspense>
    </div>
  );
};

export default EmojiPickerPopover;
